<template>
    <div class="card" @click="openDetail()">
        <div>
            <img :src="imgPlace" class="img" @error="onLoadImgError" alt=""/>
        </div>
        <div class="flex flex-col h-full flex-auto">
            <div class="flex-auto">
                <div class="font-medium text-12 text-a-black-484848">
                    {{ item.name }}
                </div>
                <div class="mt-1.5 text-9.5 font-light text-a-gray-afafaf">
                    {{ item.contact_number }}
                </div>
            </div>
            <div class="flex-none flex items-center justify-end gap-2">
                <PlaceCategoryInfo :item="item" :coordinate="currentUserLocation" />
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, inject, ref } from 'vue';
import { useRouter } from 'vue-router';
// assets
import ImgDefault from "@/assets/img_default.jpg"
// components
import PlaceCategoryInfo from './PlaceCategoryInfo.vue';

export default defineComponent({
    props: {
        item: {
            type: Object
        },
        index: {
            type: Number,
            default: 0
        }
    },
    components: { PlaceCategoryInfo },
    setup: function (props) {
        const router = useRouter()
        const imgPlace = ref(props.item.image_url)
        const currentUserLocation = inject("currentUserLocation")

        const openDetail = function () {
            /**@type {import("../model/PlaceModel").PlaceModel} */
            const obj = props.item
            obj.saveCache()

            router.push({
                name: "dealer_detail"
            })
        }

        const onLoadImgError = function () {
            imgPlace.value = ImgDefault
        }

        return {
            imgPlace,
            currentUserLocation,
            openDetail,
            onLoadImgError
        };
    },
})
</script>

<style lang="scss" scoped>
.card {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #d0d0ce;
    @apply rounded-10 flex items-start gap-3 p-3 bg-white cursor-pointer;

    .img {
        height: 70px;
        width: auto;
        @apply mx-auto object-cover rounded;
    }
}
</style>
